var version = "13.6.1";
var hcPackage = {
	version: version};

export { hcPackage as default, version };
